import { baseFontClass } from '@/components/base/Typography';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/overrides/select';
import { MultiSelect } from './MultiSelect';

export const PrimarySelect = (props) => {
  const { options, value, onChange, placeholder = 'Select an option', className } = props;

  return (
    <div className={`w-full ${className}`}>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger
          className={`w-full bg-white text-${value ? 'black' : 'muted-foreground'} h-12 px-4 py-2 text-base leading-relaxed ${baseFontClass}`}
        >
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem
              key={option.value}
              className={`text-base ${baseFontClass}`}
              value={option.value}
            >
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export const PrimaryMultiSelect = (props) => {
  const { options, value, onChange, placeholder = 'Select an option', className } = props;

  return (
    <div className={`w-full ${className}`}>
      <MultiSelect
        className="h-12 w-full bg-white px-4 py-2 text-sm"
        emptyIndicator={
          <p className="text-sm text-gray-600 dark:text-gray-400">No results found.</p>
        }
        hidePlaceholderWhenSelected
        options={options}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};
